import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["className"];
import React from 'react';
import clsx from 'clsx';
import { wrap } from '@unmapped/core/utils';
import useStyleOverride from "../../hooks/useStyleOverride.js";
import baseStyles from "./styles.module.css.js";
export var RadioInput = wrap((_ref, ref) => {
  var {
      className
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  var styles = useStyleOverride('controls/RadioInput', baseStyles);
  return /*#__PURE__*/React.createElement("input", _extends({
    type: "radio",
    className: clsx(styles.RadioInput, className)
  }, rest, {
    ref: ref
  }));
}, 'RadioInput');
export default RadioInput;
//# sourceMappingURL=index.js.map